import { render, staticRenderFns } from "./veStuPeriodEdit.vue?vue&type=template&id=44926927&scoped=true"
import script from "./veStuPeriodEdit.vue?vue&type=script&lang=js"
export * from "./veStuPeriodEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44926927",
  null
  
)

export default component.exports